// extracted by mini-css-extract-plugin
export default {"container":"chat_container__O+TA0","box":"chat_box__mym8x","chat_btn":"chat_chat_btn__JxcY-","chat_box":"chat_chat_box__NDzaM","chat_box_show":"chat_chat_box_show__S9g2S"};